export function auditActionLabel(actionType: string, lang: string = 'fr'): string {
  const normalized = (actionType || '').trim().toUpperCase();

  const labels: Record<string, { fr: string; en: string }> = {
    SUPPORT_SESSION_CREATED: { fr: 'Session support ouverte', en: 'Support session opened' },
    SUPPORT_SESSION_EXCHANGED: { fr: 'Session support echangee', en: 'Support session exchanged' },
    SUPPORT_SESSION_CLOSED: { fr: 'Session support fermee', en: 'Support session closed' },
    ADMIN_USER_ROLES_UPDATED: { fr: 'Roles utilisateur modifies', en: 'User roles updated' },
    ADMIN_FEATURE_FLAG_UPDATED: { fr: 'Feature flip mis a jour', en: 'Feature flag updated' },
    ADMIN_DISCORD_BOT_SETTINGS_UPDATED: { fr: 'Bot Discord mis a jour', en: 'Discord bot updated' },
    DELEGATION_INVITATION_CREATED: { fr: 'Invitation de delegation creee', en: 'Delegation invitation created' },
    DELEGATION_INVITATION_ACCEPTED: { fr: 'Invitation de delegation acceptee', en: 'Delegation invitation accepted' },
    DELEGATION_INVITATION_REJECTED: { fr: 'Invitation de delegation rejetee', en: 'Delegation invitation rejected' },
    DELEGATION_REVOKED: { fr: 'Delegation revoquee', en: 'Delegation revoked' }
  };

  const known = labels[normalized];
  if (known) {
    return lang === 'en' ? known.en : known.fr;
  }

  return humanizeAuditAction(actionType);
}

function humanizeAuditAction(actionType: string): string {
  return (actionType || '')
    .trim()
    .toLowerCase()
    .split('_')
    .filter(Boolean)
    .map((part, index) => index === 0 ? capitalize(part) : part)
    .join(' ');
}

function capitalize(value: string): string {
  if (!value) {
    return value;
  }
  return value.charAt(0).toUpperCase() + value.slice(1);
}
